import React, { useEffect, useRef } from 'react';
import { MatrixData } from './MatrixConfigurator';
import { drawMatrix } from '../utils/drawingUtils';
interface MatrixPreviewProps {
  matrixData: MatrixData;
}
export function MatrixPreview({
  matrixData
}: MatrixPreviewProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        drawMatrix(ctx, matrixData);
      }
    }
  }, [matrixData]);
  return <div className="flex flex-col items-center rounded-xl border-2 bg-gradient-to-br from-gray-50 to-gray-100 p-8 shadow-sm transition-shadow hover:shadow-md" style={{
    borderColor: '#E5E7EB'
  }} data-id="element-68">
      <div className="mb-6 text-center text-sm font-bold uppercase tracking-wide" style={{
      color: '#6B4423'
    }} data-id="element-69">
        Prévisualisation
      </div>
      <div className="rounded-xl bg-white p-8 shadow-lg" data-id="element-70">
        <canvas ref={canvasRef} width={400} height={400} className="max-w-full rounded-lg" data-id="element-71" />
      </div>
      <div className="mt-6 max-w-md text-center text-xs leading-relaxed" style={{
      color: '#6B7280'
    }} data-id="element-72">
        Prévisualisation du médaillon plastique d'arpentage
      </div>
    </div>;
}